import asyncComponent from '../Components/AsyncComponent.jsx'

const Dashboard = asyncComponent(() => import('../Views/Dashboard/Dashboard').then(module => module.default))
const MyProfile = asyncComponent(() => import('../Views/MyProfile/MyProfile').then(module => module.default))
const Home = asyncComponent(() => import('../Views/Home').then(module => module.default))
const Login = asyncComponent(() => import('../Views/Login/Login').then(module => module.default))

const mainRouter = [
    { path: "/login", component: Login, isPrivate: false, exact: false },
    { path: "/app", component: Dashboard, isPrivate: true, exact: false },
    { path: "/my-profile", component: MyProfile, isPrivate: true, exact: false },
    { path: "/", component: Home, isPrivate: false, exact: true },
]

export default mainRouter